import React from 'react';
import i18next from '../../../config/i18next';


import './style.scss';
import { getDiffBetweenDates, getStartOfToday, isSame, subtractFromDate } from '../../../helpers/dates';

const MemberStory = ({ entity }) => {

  const renderDate = () => {
    const createdDate = entity.getIn(['created', 0, 'value']);
    const today = getStartOfToday();
    const yesterday = subtractFromDate(today, 1, 'day');
    const lastWeek = subtractFromDate(today, 7, 'days');
    const lastMonth = subtractFromDate(today, 1, 'month');
    const diffDays = getDiffBetweenDates(today, createdDate);

    if (isSame(createdDate, today, 'day')) {
      return i18next.t('today');
    }
    else if (isSame(createdDate, yesterday, 'day')) {
      return i18next.t('yesterday');
    }
    else if (diffDays >= 2 && diffDays < 7) {
      return i18next.t('number_of_days_ago', { days: diffDays });
    }
    else if (isSame(createdDate, lastWeek, 'week')) {
      return i18next.t('a_week_ago');
    }
    else if (isSame(createdDate, lastMonth, 'month')) {
      return i18next.t('a_month_ago');
    }

  };

  return (
    <div className="MemberStory">
      <div className="MemberStory__title">
        {entity.getIn(['field_first_name', 0, 'value'])}
      </div>
      <div className="MemberStory__location">
        {entity.getIn(['field_address', 0, 'locality'])}
      </div>
      <div className="MemberStory__body">
        {entity.getIn(['body', 0, 'value'])}
      </div>
      <div className="MemberStory__date">
        {renderDate()}
      </div>
    </div>
  );
};

export default MemberStory;
